import { handleize } from "@lib/formatString";
import { nodeToId } from "@services/shopify";

const isInShopify = (data, handle) =>
  data.find((product) => (product ? product.handle === handle : false));

export function parseURLParams(product, data, router) {
  const queryString = window.location.search.slice(1);
  const urlParams = new URLSearchParams(queryString);
  let selectedProduct = null;
  let navigation = null;
  let query = { ...router.query };
  let options = null;

  navigation = urlParams
    ? Array.from(urlParams.keys()).find((key) =>
        key.toLowerCase().match(/([Cc](o|ou)l(o|ou|eu)r)/g)
      )
    : null;
  if (navigation) {
    selectedProduct = product.shopifyProducts.find((p) => {
      if (p.productColour) {
        return (
          handleize(p.productColour.title.toLowerCase()) === urlParams.get(navigation).toLowerCase()
        );
      }
    });
    selectedProduct = selectedProduct ?? product.shopifyProducts[0];
    if (selectedProduct && !isInShopify(data, selectedProduct.productReferenceV2.store.slug.current)) {
      selectedProduct = product.shopifyProducts.find((p) =>
        isInShopify(data, p.productReferenceV2.store.slug.current)
      );
    }
  } else {
    selectedProduct = product.shopifyProducts.find((p) =>
      isInShopify(data, p.productReferenceV2.store.slug.current)
    );
    navigation = "colour";
  }

  let val = null;
  if (selectedProduct?.productColour) {
    val = selectedProduct.productColour.title.toLowerCase();
  }
  if (val) {
    query = {
      ...query,
      [navigation]: handleize(val),
    };
  }

  options = selectedProduct?.productReferenceV2.store.options.map((option) => {
    if (
      urlParams?.has(option.name.toLowerCase()) &&
      navigation !== option.name.toLowerCase() &&
      !option.name.toLowerCase().match(/([Cc](o|ou)l(o|ou|eu)r)/g)
    ) {
      return option.name;
    }
  });
  options = options?.filter((element) => element !== undefined);
  const currProduct = data.find((product) =>
    product
      ? product.id === selectedProduct?.productReferenceV2.store.gid
      : false
  );

  if (currProduct && currProduct.variants.length) {
    let currVariant = currProduct.variants.find((variant) =>
      options.find((option) =>
        variant.selectedOptions.find(
          (element) =>
            element.name.toLowerCase() === option.toLowerCase() &&
            element.value.toLowerCase() === urlParams?.get(option.toLowerCase())?.toLowerCase()
        )
      )
    );

    if (!currVariant) {
      currVariant = currProduct.variants.find((variant) => variant.availableForSale);
    }

    currVariant = currVariant ?? currProduct.variants[0];

    currVariant?.selectedOptions.forEach((option) => {
      if (!option.name.toLowerCase().match(/([Cc](o|ou)l(o|ou|eu)r)/g)) {
        const optionName = handleize(option.name.toLowerCase());
        const optionValue = encodeURIComponent(handleize(option.value.toLowerCase()));
        if (!query[optionName]) {
          query = {
            ...query,
            [encodeURIComponent(optionName)]: optionValue,
          };
        }
      }
    });
  }

  return { query, selectedProduct };
}
